export const scenarios = [
  {
    name: 'אישה עם בן זוג - מקיפה',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 3,
      retirementYear: 2026,
      memberBirthDate: '1958-03-23',
      memberGender: 'female',
      hasSpouse: true,
      spouseGender: 'male',
      spouseBirthDate: '1955-04-16',
      spousePensionRate: 100,
      savingsAmount: 1500000,
      securityPeriod: 240,
      orphans: [],
      advanceMonths: 0,
      capitalizationYears: 0,
      managementFee: 0.3,
    },
  },
  {
    name: 'מקיפה - גבר עם בת זוג ויתום',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 4,
      retirementYear: 2026,
      memberBirthDate: '1962-04-10',
      memberGender: 'male',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '1957-07-19',
      spousePensionRate: 60,
      savingsAmount: 1500000,
      securityPeriod: 180,
      orphans: [{ birthdate: '2008-08-15', orphanRate: 40 }],
      advanceMonths: 3,
      capitalizationYears: 0,
      managementFee: 0.3,
    },
  },
  {
    name: 'מקיפה - גבר עם בת זוג, תאומים, היוון',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 4,
      retirementYear: 2026,
      memberBirthDate: '1960-01-29',
      memberGender: 'male',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '1976-12-19',
      spousePensionRate: 50,
      savingsAmount: 1500000,
      securityPeriod: 120,
      orphans: [
        { birthdate: '2006-10-13', orphanRate: 25 },
        { birthdate: '2006-10-13', orphanRate: 25 },
      ],
      advanceMonths: 2,
      capitalizationYears: 5,
      capitalizationRate: 25,
      managementFee: 0.3,
      insuranceEndAge: 62,
    },
  },
  // ─────────────────────────────────────────────
  // SCENARIO 4 — Intentionally missing spouseBirthDate
  // Purpose: test that validation catches missing spouse data
  // Expected: API returns validation_error for missing spouseBirthDate
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 4 — זכר עם אלמנה, נתון חסר (לבדיקת validation)',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 4,       // pension start 01/05/2026
      retirementYear: 2026,
      memberBirthDate: '1957-02-17',
      memberGender: 'male',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '',      // ← intentionally missing
      spousePensionRate: 50,
      savingsAmount: 1500000,
      securityPeriod: 0,
      orphans: [
        { birthdate: '', orphanRate: 50 },  // ← intentionally missing birthdate
      ],
      advanceMonths: 3,
      capitalizationYears: 0,
      managementFee: 0.3,
    },
  },

  // ─────────────────────────────────────────────
  // SCENARIO 5 — Male, divorced, 3 orphans, capitalization
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 5 — זכר גרוש, 3 יתומים, היוון',
    data: {
      fundType: 'supplementary', // קרן כללית
      retirementMonth: 4,        // pension start 01/05/2026
      retirementYear: 2026,
      memberBirthDate: '1966-01-31',
      memberGender: 'male',
      hasSpouse: false,
      spouseBirthDate: '',
      spouseGender: null,
      spousePensionRate: 0,
      savingsAmount: 1500000,
      securityPeriod: 240,
      orphans: [
        { birthdate: '2006-07-06', orphanRate: 33.33 },
        { birthdate: '2009-02-01', orphanRate: 33.33 },
        { birthdate: '2020-05-05', orphanRate: 33.33 },
      ],
      advanceMonths: 3,
      capitalizationYears: 5,
      capitalizationRate: 25,
      managementFee: 0.3,
      insuranceEndAge: 60,
    },
  },

  // ─────────────────────────────────────────────
  // SCENARIO 6 — Female, same-sex couple, partial coverage (<100%), retro
  // Note: widow 40% + orphan 40% = 80% total — valid, intentional
  // Better coefficient than 100% coverage
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 6 — נקבה, בת זוג נקבה, כיסוי חלקי 80%, רטרו',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 2,        // retro — pension start 01/03/2026
      retirementYear: 2026,
      memberBirthDate: '1955-07-31',
      memberGender: 'female',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '1954-06-17',
      spousePensionRate: 40,     // 40% widow — partial coverage, intentional
      savingsAmount: 1500000,
      securityPeriod: 60,
      orphans: [
        { birthdate: '2018-08-03', orphanRate: 40 },
      ],
      advanceMonths: 3,
      capitalizationYears: 0,
      managementFee: 0.3,
    },
  },

  // ─────────────────────────────────────────────
  // SCENARIO 8 — Male, spouse, 2 young orphans with rate 0 (warning case)
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 8 — זכר, בת זוג, 2 ילדים צעירים ללא שיעור קצבה',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 5,
      retirementYear: 2026,
      memberBirthDate: '1954-02-16',
      memberGender: 'male',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '1962-06-18',
      spousePensionRate: 100,
      savingsAmount: 1000000,
      securityPeriod: 180,
      orphans: [
        { birthdate: '2019-03-18', orphanRate: 0 },
        { birthdate: '2020-05-17', orphanRate: 0 },
      ],
      advanceMonths: 0,
      capitalizationYears: 1,
      capitalizationRate: 20,
      managementFee: 0.3,
      insuranceEndAge: 62,
    },
  },
  {
    name: 'מקרה 9 — זכר גיל 66, בת זוג נקבה, מקיפה',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 5,
      retirementYear: 2026,
      memberBirthDate: '1960-02-05',
      memberGender: 'male',
      hasSpouse: true,
      spouseGender: 'female',
      spouseBirthDate: '1958-01-06',
      spousePensionRate: 100,
      savingsAmount: 1000000,
      securityPeriod: 240,
      orphans: [],
      advanceMonths: 0,
      capitalizationYears: 0,
      capitalizationRate: 0,
      managementFee: 0.3,
      insuranceEndAge: 67,
    },
  },
  // ─────────────────────────────────────────────
  // CASE 14 — Male age 80, comprehensive, 4yr cap, no spouse
  // Security period capped at age 87 (+1 month, Mor config)
  // Expected: coefficient=105.341, capCoeff=44.292, effectiveSecurity=77
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 14 — זכר גיל 80, מקיפה, היוון 4 שנים, תקופת הבטחה קצוצה',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 6,
      retirementYear: 2026,
      memberBirthDate: '1945-10-01',
      memberGender: 'male',
      hasSpouse: false,
      spouseBirthDate: '',
      spouseGender: null,
      spousePensionRate: 0,
      savingsAmount: 1000000,
      securityPeriod: 240,
      orphans: [],
      advanceMonths: 3,
      capitalizationYears: 4,
      capitalizationRate: 20,
      managementFee: 0.3,
      insuranceEndAge: 67,
    },
  },
  // ─────────────────────────────────────────────
  // Case 15 — Male age 80, comprehensive, 4yr cap, securityPeriod=0
  // Expected: coefficient=97.057, capCoeff=44.292, effectiveSecurity=0
  // ─────────────────────────────────────────────
  {
    name: 'מקרה 15 — זכר גיל 80, מקיפה, היוון 4 שנים, ללא תקופת הבטחה',
    data: {
      fundType: 'comprehensive',
      retirementMonth: 6,
      retirementYear: 2026,
      memberBirthDate: '1945-10-01',
      memberGender: 'male',
      hasSpouse: false,
      spouseBirthDate: '',
      spouseGender: null,
      spousePensionRate: 0,
      savingsAmount: 1000000,
      securityPeriod: 0,
      orphans: [],
      advanceMonths: 3,
      capitalizationYears: 4,
      capitalizationRate: 20,
      managementFee: 0.3,
      insuranceEndAge: 67,
    },
  },
];
